module.exports = __webpack_public_path__ + "img/yellow_dance.4c3d90d3.png";